// extracted by mini-css-extract-plugin
export var chevron = "_fl-2";
export var dropdownItems = "_fl-0";
export var item = "_fl-1";